import {
  Calendar,
  Eye,
  MessageCircle,
  RotateCw,
  Share2,
  XCircle,
} from "lucide-react";
import { act, use, useEffect, useState } from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText, Box } from "@mui/material";
import ScheduleNACHModal from "./ScheduleNACHModal";
import Routes from '../../../../../layouts/Routes'
import { CheckFunction } from "../../../../../layouts/MainTenantconfig";
import { deactivateNachForActiveService } from "../../MISNew/API's/Actioncreator";

const MENU_ITEMS = [
  {
    id: 1,
    label: "Retry",
    action: "retry",
    icon: <RotateCw size={18} />,
    iconBg: "#E6FAF1",
    iconColor: "#059669",
  },
  // {
  //   id: 2,
  //   label: "Contacted",
  //   action: "contacted",
  //   icon: <MessageCircle size={18} />,
  //   iconBg: "#F3E8FF",
  //   iconColor: "#9333EA",
  // },
  // {
  //   id: 3,
  //   label: "View NACH History",
  //   action: "history",
  //   icon: <Eye size={18} />,
  //   iconBg: "#FFFBEB",
  //   iconColor: "#D97706",
  // },
  // {
  //   id: 4,
  //   label: "Mark Mandate Cancelled",
  //   action: "cancel",
  //   icon: <XCircle size={18} />,
  //   iconBg: "#FEF2F2",
  //   iconColor: "#EF4444",
  // },
  {
    id: 5,
    label: "Share Mandate Link",
    action: "share",
    icon: <Share2 size={18} />,
    iconBg: "#E0F7F9",
    iconColor: "#0891B2",
  },
  {
    id: 6,
    label: "Schedule NACH",
    action: "schedule",
    icon: <Calendar size={18} />,
    iconBg: "#FFF7E0",
    iconColor: "#F59E0B",
  },
];

export default function ActionMenu({ rowData, onClose, anchorEl, open }) {
  const {...tenant} = CheckFunction()
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(()=>{
    console.log("rowData",rowData)
  },[rowData])

  const handleClick = (action) => {
    if (action === "schedule") {
      setShowCalendar(true);
      return;
    }
    if (action === "cancel") {
    //  deactivateNachForActiveService()
      return;
    }
    if(action == "share"){
      let url =""
      if(rowData?.medium == "RAZORPAY"){
        url = tenant?.FRONTEND_BASE_URL + "enach/" + rowData?.loanId
      }else{
        url = tenant?.FRONTEND_BASE_URL + "enach/cashfree/" + rowData?.loanId
      }
      navigator.clipboard.writeText(url);
      alert("Link Copied")
      return;
    }
    console.log(`Action: ${action}`, rowData);
    onClose();
  };

  if (showCalendar) {
    return (
      <ScheduleNACHModal
        rowData={rowData}
        anchorEl={anchorEl}
        open={true}
        onClose={() => {
          setShowCalendar(false);
          onClose();
        }}
      />
    );
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
          borderRadius: "12px",
          minWidth: "220px",
          mt: 1,
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      {MENU_ITEMS?.map((item) => {
        if(rowData && Object.keys(rowData)?.length > 0){
          if((rowData?.nachStatus == true || rowData?.nachStatus == "true") && item?.id == 5){
            return null
          }
          if(!(rowData?.nachStatus == true || rowData?.nachStatus == "true") && item?.id == 4){
            return null
          }
        }
        return(
        <MenuItem
          key={item.id}
          onClick={() => handleClick(item.action)}
          sx={{
            py: 1.3,
            px: 2,
            fontSize: "12px",
            fontWeight: 400,
            color: "#374151",
            "&:hover": {
              backgroundColor: "#f9fafb",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: "26px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 26,
              height: 26,
              borderRadius: "7px",
              background: item.iconBg,
              color: item.iconColor,
              mr: 1.5,
            }}
          >
            {item.icon}
          </ListItemIcon>
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{
              fontSize: 12,
              fontWeight: 400,
            }}
          />
        </MenuItem>
      )})}
    </Menu>
  );
}
